// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import "../static/css/global.less";
import "../static/css/project.less";

// 富文本样式
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

// 引入echarts
import echarts from "echarts";
Vue.prototype.$echarts = echarts;

import Antd from "ant-design-vue";
import "ant-design-vue/dist/antd.css";
Vue.use(Antd);

import adminApi from "./util/common.js";
Vue.prototype.comm = adminApi;

import axios from "axios";

// 请求拦截（
axios.interceptors.request.use(
  function(config) {
    const token = sessionStorage.getItem("token");
    var is_login = config.url.indexOf("Login") == -1 ? false : true;

    if (!is_login) {
      if (config.method == "post") {
        config.data.token = token;
      }
      if (config.method == "get") {
        config.params.token = token;
      }
    }
    return config;
  },
  function(error) {
    // 请求失败的处理
    return Promise.reject(error);
  }
);

// 响应拦截
axios.interceptors.response.use(
  function(response) {
    return response.data;
  },
  function(error) {
    // 处理响应失败
    return Promise.reject(error.response.data);
  }
);
Vue.prototype.axios = axios;

// 路由守卫
router.beforeEach((to, from, next) => {
  if (to.path === "/Login") return next();
  const token = sessionStorage.getItem("token");
  if (!token) return next("/Login");
  next();
});

Vue.config.productionTip = false;
/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  components: {
    App
  },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js